
import React from 'react'
import { component_tool } from '../../../tool'
let { WizDataTable, WizIcon, WizButton, WizDivider } = component_tool

export default (self, initialValue = {},supplementary ) => {
    const columns = [
        {
            formItem: {
                type: "hidden",
                initialValue: initialValue.id
            },
            name: "id"
        },
        {
            title: "账号",
            name: "userName",
            dataIndex: "userName",
            tableItem: {},
        },
        {
            title: "姓名",
            name: "fullName",
            dataIndex: "fullName",
            tableItem: {},
        },
        {
            title: "手机号",
            name: "mobile",
            dataIndex: "mobile",
            tableItem: {},
        },
        {
            title: "证件号码",
            name: "idCard",
            dataIndex: "idCard",
            tableItem: {},
        },
        {
            title: "用户属性",
            name: "userType",
            dataIndex: "userType",
            tableItem: {},
            dict: [
                { code: 0, codeName: "培训平台用户" },
                { code: 5, codeName: "服务商用户" },
                { code: 4, codeName: "经销商用户" },
                { code: 3, codeName: "OEM部门用户" }
            ]
        },
        {
            title: "签到时间段",
            name: "signTimes",
            dataIndex: "signTimes",
            tableItem: {},
        },
        {
            title: "状态",
            name: "status",
            dataIndex: "status",
            tableItem: {},
            dict: [
                { code: 0, codeName: "未签到" },
                { code: 1, codeName: "已签到" },
                { code: 2, codeName: "补签" }
            ]
        },
        {
            title: '操作',
            tableItem: {
                width: 220,
                render: (text, record) => (
                    <WizDataTable.Oper>
                        {
                            supplementary ?
                            <WizButton tooltip="补签" onClick={e => self.supplementarySign(record)}>
                            补签
                            </WizButton>
                            :
                            null
                        }

                        <WizButton tooltip="查看已选任职" onClick={e => self._showUserPersonModal(record)}>
                            查看已选任职
                        </WizButton>

                    </WizDataTable.Oper>
                )
            }
        }
    ];

    return columns
}
